



























































































































































import { Component, Vue } from 'vue-property-decorator'
import { RequestPaging } from '@/utils/util'
import { apiSalaryRuleLists, apiSalaryRuleStatus } from '@/api/staff' // 修复这里
import { apiWorkerTypeList } from '@/api/staff'

@Component
export default class SalaryRuleList extends Vue {
    queryObj: any = {
      keyword: '',
      rule_type: '',
      worker_type_id: '',
      is_enabled: ''
    }

    tableData: any[] = []
    loading = false
    workerTypeList: any[] = []

    pager = new RequestPaging()

    getList (page?: number): void {
      page && (this.pager.page = page)
      this.loading = true
      this.pager
        .request({
          callback: apiSalaryRuleLists,
          params: {
            ...this.queryObj
          }
        })
        .then((res: any) => {
          this.tableData = res.lists || []
        })
        .finally(() => {
          this.loading = false
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        rule_type: '',
        worker_type_id: '',
        is_enabled: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/staff/salary-rule/add')
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/staff/salary-rule/edit', query: { id: row.id } })
    }

    handleToggleStatus (row: any) {
      const action = row.is_enabled ? '停用' : '启用'
      this.$confirm(`确定要${action}该薪酬规则吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiSalaryRuleStatus({
          id: row.id,
          is_enabled: row.is_enabled ? 0 : 1
        }).then(() => {
          this.$message.success(`${action}成功`)
          this.getList()
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.getList()
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.getList()
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    formatDate (timestamp: number): string {
      if (!timestamp) {
        return '-'
      }
      const date = new Date(timestamp * 1000)
      return `${date.getMonth() + 1}月${date.getDate()}日`
    }

    getRuleTypeText (type: number): string {
      const typeMap = ['', '时薪规则', '日薪规则', '计件规则', '提成规则', '混合规则']
      return typeMap[type] || '未知'
    }

    getEmploymentTypeText (type: number): string {
      const typeMap = ['', '全职直聘', '兼职', '临时工', '外包', '实习生']
      return typeMap[type] || '未知'
    }

    getBaseSalaryTypeText (type: number): string {
      const typeMap = ['', '固定工资', '时薪制', '日薪制', '计件制']
      return typeMap[type] || '未知'
    }

    getWorkerTypeList () {
      apiWorkerTypeList().then((res: any) => {
        this.workerTypeList = res.lists || []
      })
    }

    created () {
	    this.getList()
    }

    activated () {
	    this.getWorkerTypeList()
	    this.getList()
    }
}
